<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Investeringen in bedrijfsmiddelen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als de ondernemer voor de onderneming investeringen doet in bedrijfsmiddelen, kan hij recht hebben op
                investeringsaftrek.
                Dit zijn:<br/>

                <li class="list">de kleinschaligheidsinvesteringsaftrek</li>
                <li class="list">de energie-investeringsaftrek</li>
                <li class="list">de milieu-investeringsaftrek</li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Wat zijn 'bedrijfsmiddelen'?
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bedrijfsmiddelen zijn activa die een onderneming gebruikt om de bedrijfsactiviteiten uit te voeren en
                die doorgaans langer dan één jaar meegaan. Dit zijn de goederen en bezittingen die nodig zijn voor de
                dagelijkse operaties van een bedrijf, en ze kunnen variëren van tastbare objecten zoals machines en
                voertuigen tot immateriële activa zoals patenten en licenties.
                <div class="space10"></div>
                Voorbeelden van bedrijfsmiddelen:
                <li class="list">machines en apparatuur. Dit zijn de machines en apparaten die worden gebruikt voor de productie van
                    goederen of het leveren van diensten.
                </li>
                <li class="list">voertuigen. Bedrijfsauto's, vrachtwagens, en andere transportmiddelen die nodig zijn voor het
                    vervoer van goederen of personeel.
                </li>
                <li class="list">gebouwen en terreinen. Kantoorpanden, fabrieken, magazijnen, en de grond waarop deze gebouwen staan,
                    zijn essentiële bedrijfsmiddelen voor veel bedrijven.
                </li>
                <li class="list">inventaris en voorraden. Dit kan variëren van grondstoffen en halffabricaten tot gereed product dat
                    klaar is voor verkoop.
                </li>
                <li class="list">kantoormeubilair en -apparatuur. Bureaus, stoelen, computers, printers, en andere
                    kantoorbenodigdheden die dagelijks worden gebruikt.
                </li>
                <li class="list">software en IT-infrastructuur. Computersystemen, softwarelicenties, en netwerkinfrastructuur vallen
                    ook onder bedrijfsmiddelen als ze essentieel zijn voor het functioneren van het bedrijf.
                </li>
                <li class="list">immateriële activa. Dit zijn activa zonder fysieke vorm, zoals merken, handelsnamen, octrooien,
                    auteursrechten, en goodwill.
                </li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Voor welke investeringen geen recht op investeringsaftrek
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor sommige investeringen is er geen recht op investeringsaftrek. Het gaat dan om:

                <li class="list">investeringen in bepaalde bedrijfsmiddelen, zoals woonhuizen, grond, dieren, vaartuigen voor
                    representatieve doeleinden, effecten, vorderingen, goodwill en publiekrechtelijke vergunningen
                </li>
                <li class="list">investeringen in personenauto's die niet bestemd zijn voor beroepsvervoer</li>
                <li class="list">bedrijfsmiddelen die zijn bestemd voor gebruik in het buitenland</li>
                <li class="list">bedrijfsmiddelen die ter beschikking worden gesteld aan derden.<br/>
                    Voor de energie-investeringsaftrek en de milieu-investeringsaftrek geldt dit slechts in specifieke
                    gevallen. Er bestaat geen recht op energie-investeringsaftrek en milieu-investeringsaftrek als de
                    ondernemer bedrijfsmiddelen ter beschikking stelt aan:<br/>
                    - niet in Nederland wonende natuurlijke personen of niet in Nederland gevestigde lichamen.
                    In deze situatie kun je verzoeken om ontheffing voor de uitsluiting van de investeringsaftrek. Bel
                    voor meer informatie de BelastingTelefoon (0800-0543).<br/>
                    - natuurlijke personen of lichamen voor het drijven van een onderneming, als op de winst van die
                    onderneming een regeling ter voorkoming van dubbele belasting van toepassing is. In deze situatie
                    kun je verzoeken om ontheffing voor de uitsluiting van de investeringsaftrek. Bel
                    voor meer informatie de BelastingTelefoon (0800-0543).
                </li>
                <li class="list">bedrijfsmiddelen die de ondernemer van het privévermogen overbrengt naar het vermogen van de
                    onderneming
                </li>
                <li class="list"> investeringen waarvoor je verplichtingen aangaat tegenover personen die behoren tot het huishouden,
                    bloed- en aanverwanten in de rechte lijn of personen die behoren tot hun huishouden.<br/>
                    Als de ondernemer bijvoorbeeld een bedrijfsmiddel koopt van zijn vader, heb je in principe geen
                    recht op
                    investeringsaftrek.
                </li>
                <li class="list">als je ondernemer bent en een bedrijfsmiddel koopt van de bv waarvan je voor ten minste een derde
                    deel
                    aandeelhouder bent, hebt je in principe geen recht op investeringsaftrek
                </li>

                <div class="space10"></div>
                In sommige situaties kun je ontheffing krijgen voor de uitsluiting van de investeringsaftrek.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Minimum investeringsbedrag
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Bedrijfsmiddelen met een investeringsbedrag van minder dan € 450 komen niet in aanmerking voor de
                kleinschaligheidsinvesteringsaftrek.
                <div class="space10"></div>
                Voor de milieu-investeringsaftrek en de energie-investeringsaftrek is het minimale investeringsbedrag €
                2.500 per bedrijfsmiddel.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                Kleinschaligheidsinvesteringsaftrek
            </button>
        </h2>
        <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je kunt in aanmerking komen voor de kleinschaligheidsinvesteringsaftrek als je hebt geïnvesteerd
                in bedrijfsmiddelen. Het bedrag dat je van de winst mag aftrekken hangt af van het totaalbedrag dat je
                per onderneming hebt geïnvesteerd.
                <div class="space10"></div>
                Als je een bedrijfsmiddel nog niet in gebruik hebt genomen, kun je slechts investeringsaftrek claimen
                tot het bedrag dat in het jaar is betaald. Als er nog een restant aan investeringsaftrek is, kun je dat
                in volgende jaren in aftrek brengen.
                <div class="space10"></div>
                Let op! Ben je geldverstrekker? Dan kun je geen gebruik maken van de
                kleinschaligheidsinvesteringsaftrek.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading6">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                Energie-investeringsaftrek (EIA)
            </button>
        </h2>
        <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je kunt kiezen voor de energie-investeringsaftrek als je in het jaar hebt geïnvesteerd in nieuwe
                bedrijfsmiddelen die het Ministerie van Financiën en het Ministerie van Economische Zaken en Klimaat
                hebben erkend als energie-investeringen. Je moet minimaal € 2.500 per bedrijfsmiddel geïnvesteerd
                hebben. De energie-investeringsaftrek is een vast percentage.
                <div class="space10"></div>
                Let op! Je kunt voor een bedrijfsmiddel niet tegelijk gebruikmaken van de energie-investeringsaftrek en
                de
                milieu-investeringsaftrek.
                <div class="space10"></div>
                Is de ondernemer medegerechtigde of geldverstrekker? Dan kan hij geen gebruik maken van de
                energie-investeringsaftrek.
                <div class="space10"></div>
                <b>Meldingsprocedure</b><br/>
                Wil een ondernemer gebruikmaken van de energie-investeringsaftrek? Dan moet hij dit vooraf melden.
                Je meldt de investering binnen 3 maanden bij de Rijksdienst voor Ondernemend Nederland (RVO.nl). Kijk
                voor meer informatie op <a target="_blank" href="https://www.rvo.nl">de website rvo.nl</a>.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading7">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                Milieu-investeringsaftrek (MIA)
            </button>
        </h2>
        <div id="collapse7" class="accordion-collapse collapse" aria-labelledby="heading7"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Je kunt kiezen voor de milieu-investeringsaftrek als je in het jaar hebt geïnvesteerd in nieuwe
                bedrijfsmiddelen die het Ministerie van Financiën en het Ministerie van Economische Zaken en Klimaat
                hebben erkend als energie-investeringen. Er zijn 3 categorieën, waarvoor verschillende percentages
                gelden.<br/>
                <div class="space10"></div>
                Milieu-investering categorie I: Milieu-investeringsaftrek 45%<br/>
                Milieu-investering categorie II: Milieu-investeringsaftrek 36%<br/>
                Milieu-investering categorie III: Milieu-investeringsaftrek 27%<br/>

                <div class="space10"></div>
                Let op! Je kunt voor een bedrijfsmiddel niet tegelijk gebruikmaken van de energie-investeringsaftrek en
                de milieu-investeringsaftrek.
                <div class="space10"></div>
                Is de ondernemer medegerechtigde of geldverstrekker? Dan kan hij geen gebruik maken van de
                milieu-investeringsaftrek.
                <div class="space10"></div>
                <b>Meldingsprocedure</b><br/>
                Wil een ondernemer gebruikmaken van de milieu-investeringsaftrek? Dan moet hij dit vooraf melden.
                Je meldt de investering binnen 3 maanden bij de Rijksdienst voor Ondernemend Nederland (RVO.nl). Kijk
                voor meer informatie op <a target="_blank" href="https://www.rvo.nl">de website rvo.nl</a>.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading8">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                Desinvesteringsbijtelling
            </button>
        </h2>
        <div id="collapse8" class="accordion-collapse collapse" aria-labelledby="heading88"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Verkoopt de ondernemer een bedrijfsmiddel binnen 5 jaar na het begin van het jaar waarin hij de
                investering deed? Dan moet hij (een deel van) de investeringsaftrek die hij voor die investering kreeg,
                terugnemen. Hierdoor wordt e winst in het jaar van verkoop verhoogd met de desinvesteringsbijtelling.
                Deze bijtelling kan niet hoger zijn dan de investeringsaftrek die eerder is toegepast. <br/>
                Verkoopt de ondernemer voor € 2.800 (2024) of minder aan bedrijfsmiddelen? Dan hoef je niets bij te
                tellen.
                <div class="space10"></div>
                Neem voor de bijtelling het percentage dat de ondernemer bij de investeringsaftrek heeft toegepast. Je
                berekent het
                percentage door de aftrek die de ondernemer kreeg in het jaar van aanschaf, te delen door het totale
                investeringsbedrag waarover hij in dat jaar de aftrek kreeg, vermenigvuldigd met 100%. De bijtelling is
                nooit hoger dan de aftrek die de ondernemer kreeg.
                <div class="space10"></div>

                <b>Situaties gelijk aan verkoop</b><br/>
                De Belastingdienst ziet een situatie ook als verkoop, als het bedrijfsmiddel:
                <li class="list">een verhuurbestemming krijgt<br/>
                    Deze situatie geldt alleen voor de kleinschaligheidsinvesteringsaftrek, niet voor de milieu- of
                    energie-investeringsaftrek.
                </li>
                <li class="list">door de ondernemer wordt geschonken</li>
                <li class="list">naar het privévermogen wordt overgebracht</li>
                <li class="list">niet binnen 12 maanden na de investering in gebruik wordt genomen en binnen die periode ook nog niet
                    25% van de aankoopprijs is betaald
                </li>
                <li class="list">niet in gebruik wordt genomen binnen 3 jaar na het begin van het kalenderjaar waarin de ondernemer
                    de investering deed
                </li>
                <li class="list">achteraf goedkoper blijkt, door bijvoorbeeld een subsidie of korting</li>
                <li class="list">als je de investering geheel of gedeeltelijk ongedaan gemaakt wordt</li>
                <div class="space10"></div>

                <b>Desinvesteringsbijtelling bij staking van (een deel van) je onderneming</b><br/>
                Heeft de ondernemer (een deel van) de onderneming gestaakt? Dan is hij, bij vervreemding of overbrenging
                naar de privévermogen, desinvesteringsbijtelling verschuldigd over de bedrijfsmiddelen waarvoor hij in
                het verleden investeringsaftrek hebt toegepast en waarvan de termijn waarbinnen
                desinvesteringsbijtelling is verschuldigd, nog niet is verstreken.
            </div>
        </div>
    </div>

</div>

